module.exports = __webpack_public_path__ + "img/leona_schnee_ocular.c1e1465d.jpg";